var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "audit__log" },
    [
      _c("HeaderControlsAuditLog"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fixed-top-bar-padding audit-log-wrapper" },
        [
          _c("AuditLogHeader", {
            attrs: { currentTab: _vm.currentTab },
            on: { click: _vm.activateTab }
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm.auditLogAll
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("AuditLogBox", { attrs: { auditLogs: _vm.auditLogs } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogDeliverablesT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("AuditLogBox", {
                    attrs: { auditLogs: _vm.auditLogDeliverables }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogProjectsT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("AuditLogBox", {
                    attrs: { auditLogs: _vm.auditLogProjects }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogTagsT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("AuditLogBox", { attrs: { auditLogs: _vm.auditLogTags } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogContactsT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("AuditLogBox", {
                    attrs: { auditLogs: _vm.auditLogContacts }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogCoordinatorsT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("AuditLogBox", {
                    attrs: { auditLogs: _vm.auditLogCoordinators }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.auditLogDepartmentsT
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("AuditLogBox", {
                    attrs: { auditLogs: _vm.auditLogDepartments }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "deliverable-header" }, [
        _c("h2", [
          _c("div", { staticClass: "media-call-icon pointer-default" }, [
            _c("img", {
              attrs: { src: require("@/csmworkflow/img/audit-log-black.svg") }
            })
          ]),
          _vm._v("\n          Audit Logs\n        ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }